import {AfterViewChecked, ChangeDetectorRef, Component, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ExcelService} from '@shared/services/global';
import {isArray} from '@shared/utils';

@Component({
  standalone: false,
  selector: 'app-import-excel-common',
  templateUrl: 'import-excel.component.html',
  styles: [`
 .detail-content {
 background: var(--hover-bg);
 border: 1px solid #eee;
 height: 200px;
 box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;
 overflow: auto;
 padding: 5px;
 }

 .excel-loading-icon {
 display: inline-block;
 animation: excel-loading-spin 1s linear infinite;
 }

 @keyframes excel-loading-spin {
 to {
 transform: rotate(360deg);
 }
 }
 `]

})
export class ImportExcelModalComponent implements AfterViewChecked {

  @Input() data: any
  totalImported = 0
  totalRecord = 0
  totalSuccess = 0
  totalError = 0
  totalWarning = 0
  logs: any = []
  per = 0;
  finish = false

  isArray = isArray

  constructor(
    public activeModal: NgbActiveModal,
    private cdRef: ChangeDetectorRef,
    private excelService: ExcelService,
  ) {

  }

  calcPer(num: number, total: number) {
    if (total > 0 && num > 0) {
      return Math.ceil(num / total * 100)
    }
    return 0
  }

  ngAfterViewChecked() {
    this.per = this.calcPer(this.totalRecord, this.totalImported)
    this.cdRef.detectChanges()
  }

  saveLog() {
    this.excelService.saveLog()
  }
}
